import { Select } from 'peach/components'
import { useInternalTeamsGet } from 'core/types'
import { useCompanyInfo } from 'core/stores/bootstrap'
import _ from 'lodash'

const CompanyTeamSelect = (props) => {
  const company = useCompanyInfo()
  const companyId = props.companyId || company.id

  const { data: teams = [], isLoading } = useInternalTeamsGet({ companyId })

  const options = _.map(teams, (team) => {
    const { id, name } = team

    return {
      value: id,
      label: name ? `${name} (${id})` : id,
    }
  })

  return (
    <Select
      {...props}
      label='Team'
      options={options}
      isLoading={isLoading}
      disabled={isLoading || !companyId}
    />
  )
}

export default CompanyTeamSelect
